import { z } from 'zod';

export const ProfileSchema = z.object({
  displayName: z
    .string()
    .min(1, 'Display name is required')
    .max(80, 'Maximum 80 characters'),
});

export type ProfileValues = z.infer<typeof ProfileSchema>;

export const ChangePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: z.string().min(8, 'New password must be at least 8 characters'),
    confirmPassword: z.string().min(1, 'Confirm your new password'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type ChangePasswordValues = z.infer<typeof ChangePasswordSchema>;
